
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashionunited-career-center",
      function () {
        return require("private-next-pages/fashionunited-career-center.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashionunited-career-center"])
      });
    }
  